module.exports = __webpack_public_path__ + "img/flag_za.5439b838.png";